import { Component, OnInit, ViewChild, inject } from '@angular/core';
import {ClsConfig} from '../../../util/cls-config';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxExcelExporterService, IgxPdfExporterService } from '@infragistics/igniteui-angular/grids/core';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {ClsObjConfiguracionGrid} from '../../../clases-pu/util/cls-obj-configuracion-grid';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {ClsUtil} from '../../../util/cls-util';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {TranslateModule} from '@ngx-translate/core';
import {ClsTipoJornada} from "../../../core/models/cls-catalogos";
import {GenericoService} from "../../../core/services/generico.service";
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import { CrearComponenteDinamicoService } from '../../../core/services/crear-componente-dinamico.service';

@Component({
  selector: 'app-tipos-jornadas',
  templateUrl: './tipos-jornadas.component.html',
  styleUrls: ['./tipos-jornadas.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    MasOpcionesGridComponent,
  ]
})
export class TiposJornadasComponent extends ClsConfig implements OnInit {
  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);
  private tipoMsg = inject(TipoMensajesService);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridTipoJornada', {read: IgxGridComponent, static: true})
  public gridTipoJornada: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;

  public errorAlCargar: boolean;
  public activarBotones = false;

  public dataTipoJor: ClsTipoJornada[] = [];

  // clase catalogos
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid;
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  ngOnInit() {
  }

  public async cargarTiposDeJornadas() {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      this.errorAlCargar = false;
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.dataTipoJor = await this.servicioGen.getURLTextAwait(`assets/json/tipoJornadas.json`, 'json');
        this.gridTipoJornada.data = this.dataTipoJor;
        this.errorAlCargar = false;
      } catch (e) {
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      } finally {
        this.tipoMsg.cerrarWaitDialog();
      }
    }
  }

  public handleRowSelection() {
    this.gridTipoJornada.nativeElement.focus();
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridTipoJornada, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.TIPO_JORNADA'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridTipoJornada.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridTipoJornada,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.TIPO_JORNADA'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridTipoJornada.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridTipoJornada.filteringLogic = FilteringLogic.Or;
    this.gridTipoJornada.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridTipoJornada.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridTipoJornada.getRowData(rowSeleccionados[0]);
      this.gridTipoJornada.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
